import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  serasaObj;
}

@Component({
  selector: 'app-relato',
  templateUrl: './relato.component.html',
  styleUrls: ['./relato.component.scss']
})
export class RelatoComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  serasaObj = null;
  concentreSummaryRows = [];

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    // serasaObj is BusinessInformationDto from /api/serasa/report/{cnpj}
    const negative = this.serasaObj && this.serasaObj.NegativeAnnotations;
    if (negative) {
      this.concentreSummaryRows = [
        { label: 'Dívidas Vencidas', items: negative.CollectionRecords, summary: negative.CollectionRecordsSummary },
        { label: 'Ações Judiciais', items: negative.Lawsuits, summary: negative.LawsuitsSummary },
        { label: 'Protestos', items: negative.Protests, summary: negative.ProtestsSummary },
        { label: 'Cheques sem Fundos', items: negative.BadChecks, summary: negative.BadChecksSummary },
        { label: 'Falências / Concordatas', items: negative.Bankruptcies, summary: negative.BankruptciesSummary }
      ];
    }
  }

  closeModal() {
    this.close();
  }

  sumCapitais(obj) {
    if (!obj || !obj.length) return 0;
    let total = 0;
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].Capital) {
        total += obj[i].Capital;
      }
    }
    return total;
  }

  sumParticipantsCapital(participants) {
    if (!participants || !participants.length) return 0;
    let total = 0;
    for (let i = 0; i < participants.length; i++) {
      if (participants[i].participationPercentageCapital) {
        total += participants[i].participationPercentageCapital;
      }
    }
    return total;
  }

  // Marca, no padrão da Legenda/coluna Restrição do Concentre, se alguma empresa participada
  // possui participante com restrictionSign=true (a API só traz esse sinal por participante,
  // não por empresa).
  hasRestrictedParticipant(part) {
    return part && (part.restrictionSign === true ||
      (part.participants && part.participants.some(p => p.restrictionSign === true)));
  }

  itemCount(summary, items) {
    if (summary && summary.Count !== null && summary.Count !== undefined) return summary.Count;
    return items ? items.length : 0;
  }

  itemBalance(summary, items) {
    if (summary && summary.Balance !== null && summary.Balance !== undefined) return summary.Balance;
    if (!items) return 0;
    return items.reduce((total, item) => total + (item.Amount || 0), 0);
  }

  avalista(item) {
    if (!item || item.Principal === null || item.Principal === undefined) return '—';
    return item.Principal === true ? 'Não' : 'Sim';
  }

  firstOccurrence(summary, items) {
    if (summary && summary.FirstOccurrence) return summary.FirstOccurrence;
    return items && items.length ? items[0].FirstOccurrence : null;
  }

  lastOccurrence(summary, items) {
    if (summary && summary.LastOccurrence) return summary.LastOccurrence;
    return items && items.length ? items[0].LastOccurrence : null;
  }

  firstItem(items) {
    return items && items.length ? items[0] : {};
  }

  // Equivalente ao "ParticipantesAnotacoes" do relatório legado: participantes (de qualquer empresa
  // participada) com restrictionSign=true, deduplicados por documento — a Serasa repete o mesmo
  // participante em várias empresas participadas.
  getRestrictedParticipants() {
    const participateds = this.serasaObj && this.serasaObj.OptionalFeatures
      && this.serasaObj.OptionalFeatures.companyParticipationsReport
      && this.serasaObj.OptionalFeatures.companyParticipationsReport.participateds;
    const seen = {};
    const result = [];
    const addParticipant = (participant, defaultType) => {
      if (!participant || participant.restrictionSign !== true) return;
      const documentId = participant.documentId;
      const name = participant.participantName || participant.name;
      const key = documentId || name;
      if (!key || seen[key]) return;
      seen[key] = true;
      result.push({
        participantName: name,
        documentId: documentId,
        participationType: participant.participationType || participant.role || defaultType
      });
    };

    const qsa = this.serasaObj && this.serasaObj.OptionalFeatures && this.serasaObj.OptionalFeatures.QSAReport;
    const partners = qsa && qsa.partnerCompleteReport && qsa.partnerCompleteReport.partnersList;
    const directors = qsa && qsa.directorCompleteReport && qsa.directorCompleteReport.directorsList;
    (partners || []).forEach(partner => addParticipant(partner, 'Sócio'));
    (directors || []).forEach(director => addParticipant(director, 'Administrador'));

    for (const participated of (participateds || [])) {
      const participants = participated.participants || [];
      for (const participant of participants) {
        addParticipant(participant, 'Participante');
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/relato/relato.component.ts